<script>
import VueCharts from 'vue-chartjs'

export default {
  name: 'LineChartWrapper',
  extends: VueCharts.Line,

  mixins: [VueCharts.mixins.reactiveProp],

  props: ['chartData', 'options'],

  mounted() {
    this.renderChart(this.chartData, this.options)
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/customer-intelligence/components/LineChartWrapper.vue